import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogSurface,
  DialogTitle,
  Spinner,
} from "@fluentui/react-components";
import { useState } from "react";
import { useStyles } from "./ActionDialog.styles";
import IDialogProperties from "./ActionDialog.types";

export const ActionDialog = (props: IDialogProperties): JSX.Element => {
  const styles = useStyles();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleConfirmation = async () => {
    if (!props.onConfirmation) return;
    setIsLoading(true);
    try {
      await props.onConfirmation();
    } finally {
      setIsLoading(false);
    }
  };

  const showSpinner = props.hasSpinner || isLoading;
  const spinnerLabel = props.spinnerMessage ?? "Deleting...";

  return (
    <Dialog open={props.isVisible} onOpenChange={props.onDismiss}>
      <DialogSurface className={styles.dialogSurface} aria-busy={showSpinner}>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogBody className={styles.dialogBody}>
          <p> {props.message}</p>
        </DialogBody>
        <DialogActions>
          {props.onDismiss && props.dismissMessage !== undefined && (
            <Button
              appearance="secondary"
              onClick={props.onDismiss}
              disabled={showSpinner}
              autoFocus
            >
              {props.dismissMessage}
            </Button>
          )}
          {props.onConfirmation && (
            <Button
              appearance="primary"
              onClick={handleConfirmation}
              className={
                props.isDangerous ? styles.dangerButton : styles.button
              }
              disabled={showSpinner}
              icon={showSpinner ? <Spinner size="tiny" /> : undefined}
            >
              {showSpinner ? spinnerLabel : props.confirmationMessage}
            </Button>
          )}
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
};
